/**
 * question: Which of the two is your main business purpose?
 * == baseline
 * question12
 * 
 * @param props 
 * @returns 
 */
export const socialImpactPurposeTotalCalculation = (props: any) => {
    return props.baselineSubmissions
        .filter((submission: any) => ['Item 1', 'Item 2'].includes(submission.question12)).length;
}